"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const buildCallableStopRecordingAudio = (stopRecordingAudio) => async ({ functionId, callbacks, executeProcesses, }) => {
    try {
        const path = await stopRecordingAudio();
        executeProcesses(functionId, callbacks.onFinishRecording, path);
    }
    catch (error) {
        const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
        executeProcesses(functionId, callbacks.onError, errorMessage);
    }
};
exports.default = buildCallableStopRecordingAudio;
